import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/forms/$formId/$responseId` activates the response-detail
// column (col 3). The Forms LAYOUT route (forms.tsx) reads `$responseId` from
// the leaf match and renders the column; this child just contributes the param.
export const Route = createFileRoute("/$orgSlug/$eventSlug/forms/$formId/$responseId")({
  component: () => null,
})
